import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import {
  renderAutoForm,
} from './RoutingHelper';
import SuspensePageLoader from '../Utils/SuspensePageLoader';
import LostPage from '../StaticPages/404/LostPage';
import FlaggedPage from '../StaticPages/Flagged/Flagged';

const FormContainer = lazy(() => import(/* webpackChunkName: "FormContainer" */ '../AutoSavings/Forms/FormContainers/FormContainer'));
const News = lazy(() => import(/* webpackChunkName: "News" */ '../StaticPages/News/News'));
const About = lazy(() => import(/* webpackChunkName: "About" */ '../StaticPages/About/About'));
const OttoAbout = lazy(() => import(/* webpackChunkName: "OttoAbout" */ '../StaticPages/About/OttoAbout'));
const Privacy = lazy(() => import(/* webpackChunkName: "Privacy" */ '../StaticPages/Legal/Privacy'));
const OttoPrivacy = lazy(() => import(/* webpackChunkName: "OttoPrivacy" */ '../StaticPages/Legal/OttoPrivacy'));
const Terms = lazy(() => import(/* webpackChunkName: "Terms" */ '../StaticPages/Legal/Terms'));
const OttoTerms = lazy(() => import(/* webpackChunkName: "OttoTerms" */ '../StaticPages/Legal/OttoTerms'));
const Carriers = lazy(() => import(/* webpackChunkName: "Carriers" */ '../AutoSavings/Carriers/Carriers'));
const OttoCarriers = lazy(() => import(/* webpackChunkName: "OttoCarriers" */ '../AutoSavings/Carriers/OttoCarriers'));
const MediaAlphaLB = lazy(() => import(/* webpackChunkName: "MediaAlphaLB" */ '../AutoSavings/LeaveBehind'));
const ShuffleTY = lazy(() => import(/* webpackChunkName: "MediaAlphaLB" */ '../AutoSavings/Forms/FormContainers/Shuffle/TYPages/TYPage'));
const AutoGuide = lazy(() => import(/* webpackChunkName: "LifeInsuranceGuide" */ '../StaticPages/InsuranceGuides/AutoInsuranceGuide'));
const HomeGuide = lazy(() => import(/* webpackChunkName: "HomeInsuranceGuide" */ '../StaticPages/InsuranceGuides/HomeInsuranceGuide'));
const PetGuide = lazy(() => import(/* webpackChunkName: "PetInsuranceGuide" */ '../StaticPages/InsuranceGuides/PetInsuranceGuide'));
const LifeGuide = lazy(() => import(/* webpackChunkName: "LifeInsuranceGuide" */ '../StaticPages/InsuranceGuides/LifeInsuranceGuide'));
const CommercialGuide = lazy(() => import(/* webpackChunkName: "CommercialInsuranceGuide" */ '../StaticPages/InsuranceGuides/CommercialInsuranceGuide'));

const ASRoutes = function ({
  state, variant, updateAppState, redirect, setAlternativeVariantObject, switchToEnglishVariant, switchToOriginalVariant,
}) {
  const renderFlaggedOrForm = (state.denyListed || state.international || state.unsupportedState)
    ? (
      <Navigate
        replace
        to="/flagged"
        {...{
          state, variant, updateAppState, redirect,
        }}
      />
    )
    : (
      <FormContainer
        {...state}
        variant={variant}
        updateAppState={updateAppState}
        setAlternativeVariantObject={setAlternativeVariantObject}
        switchToEnglishVariant={switchToEnglishVariant}
        switchToOriginalVariant={switchToOriginalVariant}
      />
    );
  return (
    <Router>
      <Routes>
        <Route
          exact
          key={`${111}_route`}
          path="/"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              {renderFlaggedOrForm}
            </Suspense>
          )}
        />
        {renderAutoForm('2000/ty-page', { ...state }, '', updateAppState, ShuffleTY, false, false, 22)}
        <Route
          exact
          key="news/"
          path="/news/"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <News {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
          )}
        />
        <Route
          exact
          key="auto-guide"
          path="/auto-guide"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <AutoGuide {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
            )}
        />
        <Route
          exact
          key="home-guide"
          path="/home-guide"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <HomeGuide {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
            )}
        />
        <Route
          exact
          key="pet-guide"
          path="/pet-guide"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <PetGuide {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
            )}
        />
        <Route
          exact
          key="life-guide"
          path="/life-guide"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <LifeGuide {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
            )}
        />
        <Route
          exact
          key="commercial-guide"
          path="/commercial-guide"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <CommercialGuide {...{
                state, variant, updateAppState, redirect,
              }}
              />
            </Suspense>
            )}
        />
        <Route
          exact
          key="about"
          path="/about"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              {state.brand === 'OttoInsurance'
                ? (
                  <OttoAbout {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )
                : (
                  <About {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )}
            </Suspense>
          )}
        />
        <Route
          exact
          key="privacy"
          path="/privacy"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              {state.brand === 'OttoInsurance'
                ? (
                  <OttoPrivacy {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )
                : (
                  <Privacy {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )}
            </Suspense>
          )}
        />
        <Route
          exact
          key="terms"
          path="/terms"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              {state.brand === 'OttoInsurance'
                ? (
                  <OttoTerms {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )
                : (
                  <Terms {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )}
            </Suspense>
          )}
        />
        <Route
          exact
          key="carriers"
          path="/carriers"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              {state.brand === 'OttoInsurance'
                ? (
                  <OttoCarriers {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )
                : (
                  <Carriers {...{
                    state, variant, updateAppState, redirect,
                  }}
                  />
                )}
            </Suspense>
          )}
        />
        <Route
          exact
          key="lb"
          path="/lb"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <MediaAlphaLB {...state} />
            </Suspense>
          )}
        />
        <Route
          exact
          key="flagged"
          path="/flagged"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <FlaggedPage {...state} />
            </Suspense>
          )}
        />
        <Route
          path="*"
          element={(
            <Suspense fallback={<SuspensePageLoader />}>
              <LostPage {...state} />
            </Suspense>
          )}
        />
      </Routes>
    </Router>
  );
};

ASRoutes.propTypes = {
  state: PropTypes.object.isRequired,
  variant: PropTypes.object.isRequired,
  updateAppState: PropTypes.func.isRequired,
  redirect: PropTypes.string.isRequired,
  setAlternativeVariantObject: PropTypes.func.isRequired,
  switchToEnglishVariant: PropTypes.func.isRequired,
  switchToOriginalVariant: PropTypes.func.isRequired,
};

export {
  ASRoutes,
};

ASRoutes.propTypes = {
  state: PropTypes.object,
  variant: PropTypes.object,
  updateAppState: PropTypes.func,
  redirect: PropTypes.string,
  setAlternativeVariantObject: PropTypes.func,
  switchToEnglishVariant: PropTypes.func,
  switchToOriginalVariant: PropTypes.func,
};

ASRoutes.defaultProps = {
  state: {},
  variant: {},
  updateAppState: () => {
  },
  redirect: '',
  setAlternativeVariantObject: () => {
  },
  switchToEnglishVariant: PropTypes.func,
  switchToOriginalVariant: PropTypes.func,
};
